import $ from "jquery";

const preventCopyPaste = {
    o: $('.prevent-copy-paste'),
    bindEvents() {
        this.o.on('cut copy paste', (evt) => {
            evt.preventDefault();
        });
    }
};

// DOM ready
$(() => {
    if (preventCopyPaste.o.length) {
        preventCopyPaste.bindEvents();
    }
});

export default preventCopyPaste;
